/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISubscriptionPlan } from 'app/shared/model/subscription-plan.model';
import { PaymentType } from 'app/shared/model/enumerations/payment-type.model';
import { PaymentReason } from 'app/shared/model/enumerations/payment-reason.model';

export interface ISubscriptionPayment {
  id?: string;
  paymentType?: keyof typeof PaymentType;
  paymentReason?: keyof typeof PaymentReason;
  gatewayVendor?: string;
  transactionId?: string;
  customerId?: string | null;
  active?: boolean;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  cursor?: number;
  subscriptionPlan?: ISubscriptionPlan;
}

export const defaultValue: Readonly<ISubscriptionPayment> = {
  active: false,
};
